<template>
  <div id="app">
    <Landing/>
    <notifications group="foo" />
  </div>
</template>

<script>
import Landing from './components/Landing.vue'
import userModule from './state/userModule.js'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user: userModule
  }
})
export default {
  name: 'app',
  components: {
    Landing
  },
  store: store
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
